import { Context, CoreDict, Logger, TranslationService, throwInternalError } from '../../../common'
import { AppAuthService, hasUserPermission } from './appAuthService'
import { PermissionsService, RequestedPermission, checkPermissionImpl } from './serverPermissionService'

export class AppsPermissionService implements PermissionsService {
  private logger = new Logger('AppsPermissionService')

  authService: AppAuthService | undefined

  constructor(
    private opts: {
      translationService: TranslationService<CoreDict>
    },
  ) {
    this.logger.debug({}, '<da0c5b56> Initialized')
  }

  checkPermission(ctx: Context, permission: RequestedPermission): Promise<void> {
    return checkPermissionImpl(
      ctx,
      (ctx, perm) => this.hasPermission(ctx, perm),
      this.opts.translationService,
      permission,
    )
  }

  async hasPermission(ctx: Context, permission: RequestedPermission): Promise<boolean> {
    const authService = this.authService ?? throwInternalError('<073708d9> Auth service not provided')
    if (ctx.internal) return true // internal requests allowed
    return hasUserPermission(authService.permissions.value, permission)
  }
}
